import { I18n } from '@calendly/i18n';
import { useIsControl } from '@calendly/ui/components/select';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { LocationIcon } from 'components/core/location_icon';
import { LocationIconColor } from '../../location_icon_color';
import { useNewDropdownSelector } from '../selectors';
import { useStateValue } from '../state_provider';
const wrapperCss = "wbuvpb7";
const Wrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(wrapperCss, props.className)} />;
});
const labelCss = "l9g4cje";
const Label = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(labelCss, props.className)} />;
});
const descriptionCss = "d13g448u";
const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
const getLabelText = kind => ({
  ask_invitee: I18n.t('publisher.event_types.location.ask_invitee.label'),
  custom: I18n.t('publisher.event_types.location.custom.label'),
  google_conference: I18n.t('publisher.event_types.location.google_conference.label'),
  gotomeeting_conference: I18n.t('publisher.event_types.location.gotomeeting_conference.label'),
  physical: I18n.t('publisher.event_types.location.physical.label'),
  zoom_conference: I18n.t('publisher.event_types.location.zoom_conference.label'),
  inbound_call: I18n.t('publisher.event_types.location.inbound_call.label'),
  outbound_call: I18n.t('publisher.event_types.location.outbound_call.label'),
  microsoft_teams_conference: I18n.t('publisher.event_types.location.microsoft_teams_conference.label'),
  webex_conference: I18n.t('publisher.event_types.location.webex_conference.label')
})[kind];
const getDescriptionText = kind => ({
  ask_invitee: I18n.t('publisher.event_types.location.ask_invitee.description'),
  custom: I18n.t('publisher.event_types.location.custom.description'),
  google_conference: I18n.t('publisher.event_types.location.google_conference.description'),
  gotomeeting_conference: I18n.t('publisher.event_types.location.gotomeeting_conference.description'),
  physical: I18n.t('publisher.event_types.location.physical.description'),
  zoom_conference: I18n.t('publisher.event_types.location.zoom_conference.description'),
  inbound_call: I18n.t('publisher.event_types.location.inbound_call.description'),
  outbound_call: I18n.t('publisher.event_types.location.outbound_call.description'),
  microsoft_teams_conference: I18n.t('publisher.event_types.location.microsoft_teams_conference.description'),
  webex_conference: I18n.t('publisher.event_types.location.webex_conference.description')
})[kind];
const iconColumnCss = "i1xcssnw";
const IconColumn = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(iconColumnCss, props.className)} />;
});
const iconWrapperCss = "i1up2vlm";
const IconWrapper = forwardRef((props, ref) => <LocationIconColor ref={ref} {...props} className={classNames(iconWrapperCss, props.className)} />);
const newIconWrapperCss = "n1a966eg";
const NewIconWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(newIconWrapperCss, props.className)} />;
});
export const OptionBody = ({
  value
}) => {
  const state = useStateValue();
  const useNewDropdown = useNewDropdownSelector(state);
  const showDescription = !useIsControl();
  if (useNewDropdown) {
    return <Wrapper>
        <IconColumn>
          <NewIconWrapper kind={value}>
            <LocationIcon kind={value} />
          </NewIconWrapper>
        </IconColumn>
        <Label>
          {getLabelText(value)}
        </Label>
      </Wrapper>;
  }
  return <Wrapper>
      <IconColumn>
        <IconWrapper kind={value}>
          <LocationIcon kind={value} />
        </IconWrapper>
      </IconColumn>
      <Label>
        {getLabelText(value)}
        {showDescription && <Description>
            {getDescriptionText(value)}
          </Description>}
      </Label>
    </Wrapper>;
};

require("./option_body.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./option_body.js");